<div class="operations-app" [class.operations-bare]="bare">
  <header class="operations-header" *ngIf="!bare">
    <a class="operations-brand" [routerLink]="home" aria-label="Onticket, inicio del panel">onticket</a>
    <span class="operations-area">{{ label }}</span>
    <a class="operations-public-link" routerLink="/welcome"><span>Ir a Onticket</span><mat-icon aria-hidden="true">north_east</mat-icon></a>
    <button class="operations-menu-toggle" type="button" *ngIf="!desktop" (click)="navigation.toggle()"
      aria-controls="operations-navigation" [attr.aria-expanded]="navigation.opened"
      [attr.aria-label]="navigation.opened ? 'Cerrar menú del panel' : 'Abrir menú del panel'">
      <mat-icon aria-hidden="true">{{ navigation.opened ? 'close' : 'menu' }}</mat-icon>
    </button>
  </header>
  <mat-sidenav-container>
    <mat-sidenav #navigation id="operations-navigation" class="operations-navigation"
      [mode]="desktop ? 'side' : 'over'" [opened]="desktop && !bare" [disableClose]="desktop"
      [autoFocus]="!desktop" [fixedInViewport]="true" role="navigation" aria-label="Navegación del panel">
      <div class="operations-nav-content">
        <header class="operations-mobile-nav-heading"><strong>{{ label }}</strong>
          <button mat-icon-button type="button" (click)="navigation.close()" aria-label="Cerrar menú del panel" cdkFocusInitial><mat-icon aria-hidden="true">close</mat-icon></button>
        </header>
        <section *ngFor="let group of groups; trackBy: trackGroup" class="operations-nav-group">
          <h2>{{ group.label }}</h2>
          <a *ngFor="let link of group.links; trackBy: trackLink" [routerLink]="link.path" routerLinkActive="operations-nav-active"
            #active="routerLinkActive" [attr.aria-current]="active.isActive ? 'page' : null" (click)="closeMobile()">
            <mat-icon aria-hidden="true">{{ link.icon }}</mat-icon><span>{{ link.label }}</span>
          </a>
        </section>
        <div class="operations-nav-bottom">
          <a *ngIf="area === 'admin' && authService.getUser().isWorker" routerLink="/workers/dashboard" (click)="closeMobile()"><mat-icon aria-hidden="true">qr_code_scanner</mat-icon>Equipo del evento</a>
          <a *ngIf="area === 'workers' && authService.getUser().isAdmin" [routerLink]="authService.getUser().isStaff ? '/admin/staff/businesses' : '/admin/dashboard'" (click)="closeMobile()"><mat-icon aria-hidden="true">dashboard</mat-icon>Panel del negocio</a>
          <a routerLink="/welcome" (click)="closeMobile()"><mat-icon aria-hidden="true">north_east</mat-icon>Ir a Onticket</a>
          <div class="operations-account"><mat-icon aria-hidden="true">account_circle</mat-icon><div><small>SESIÓN ACTIVA</small><strong>{{ authService.getUser().displayName || 'Mi cuenta' }}</strong></div></div>
          <button type="button" (click)="logout()"><mat-icon aria-hidden="true">logout</mat-icon>Cerrar sesión</button>
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="operations-content">
        <a *ngIf="parent && !bare" class="operations-back" [routerLink]="parent.path"><mat-icon aria-hidden="true">arrow_back</mat-icon>{{ parent.label }}</a>
        <ng-content></ng-content>
      </div>
      <footer class="operations-footer" *ngIf="!bare"><span>onticket · {{ label }}</span><a routerLink="/welcome">Volver a la app</a></footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
